var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("h2", { staticClass: "page-title-bar" }, [
        _c("img", {
          staticClass: "ico",
          attrs: {
            src: require("@/assets/img/ic_export_records.svg"),
            alt: "solum esl dashboard"
          }
        }),
        _vm._v(" " + _vm._s(_vm.$t("Sensor Export Records")) + " ")
      ]),
      _c(
        "div",
        { staticClass: "searchArea" },
        [
          _c(
            "div",
            { staticClass: "col-2 d-flex align-center pb-0" },
            [
              _c(
                "v-menu",
                {
                  attrs: {
                    "offset-y": "",
                    "close-on-content-click": false,
                    "content-class": "columnMenu"
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "activator",
                      fn: function(ref) {
                        var on = ref.on
                        var attrs = ref.attrs
                        return [
                          _c(
                            "v-btn",
                            _vm._g(
                              _vm._b(
                                {
                                  staticClass: "manage-btn btn",
                                  attrs: { text: "", small: "" }
                                },
                                "v-btn",
                                attrs,
                                false
                              ),
                              on
                            ),
                            [
                              _vm._v(
                                " " + _vm._s(_vm.$t("Manage Columns")) + " "
                              ),
                              _c(
                                "v-icon",
                                {
                                  class: { rotate: _vm.menuOpen },
                                  attrs: { right: "" }
                                },
                                [_vm._v(" mdi-chevron-down ")]
                              )
                            ],
                            1
                          )
                        ]
                      }
                    }
                  ]),
                  model: {
                    value: _vm.menuOpen,
                    callback: function($$v) {
                      _vm.menuOpen = $$v
                    },
                    expression: "menuOpen"
                  }
                },
                [
                  _c(
                    "v-card",
                    { staticClass: "column-card" },
                    [
                      _c("v-card-title", { staticClass: "column-header" }, [
                        _vm._v(" " + _vm._s(_vm.$t("Select Columns")) + " ")
                      ]),
                      _c("v-divider"),
                      _c(
                        "v-list",
                        { staticClass: "select-all", attrs: { dense: "" } },
                        [
                          _c(
                            "v-list-item",
                            [
                              _c("v-checkbox", {
                                attrs: {
                                  "input-value": _vm.isAllSelected,
                                  "hide-details": ""
                                },
                                on: { change: _vm.toggleSelectAll }
                              }),
                              _c("v-list-item-title", [
                                _vm._v(" " + _vm._s(_vm.$t("Select All")) + " ")
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c("v-divider"),
                      _c(
                        "v-card-text",
                        { staticClass: "column-list" },
                        [
                          _c(
                            "v-list",
                            { attrs: { dense: "" } },
                            _vm._l(
                              _vm.recordHeaders.slice(
                                2,
                                _vm.recordHeaders.length - 1
                              ),
                              function(header) {
                                return _c(
                                  "v-list-item",
                                  { key: header.value },
                                  [
                                    _c("v-checkbox", {
                                      attrs: {
                                        value: header.text,
                                        "hide-details": ""
                                      },
                                      model: {
                                        value: _vm.visibleColumns,
                                        callback: function($$v) {
                                          _vm.visibleColumns = $$v
                                        },
                                        expression: "visibleColumns"
                                      }
                                    }),
                                    _c(
                                      "v-list-item-title",
                                      { staticClass: "column-text" },
                                      [_vm._v(" " + _vm._s(header.text) + " ")]
                                    )
                                  ],
                                  1
                                )
                              }
                            ),
                            1
                          )
                        ],
                        1
                      ),
                      _c("v-divider"),
                      _c(
                        "v-card-actions",
                        { staticClass: "column-footer" },
                        [
                          _c(
                            "v-btn",
                            {
                              staticStyle: {
                                background: "#c57171",
                                color: "#ffffff !important",
                                width: "80px"
                              },
                              attrs: { color: "error", text: "", small: "" },
                              on: {
                                click: function($event) {
                                  _vm.menuOpen = false
                                }
                              }
                            },
                            [_vm._v(" " + _vm._s(_vm.$t("Cancel")) + " ")]
                          ),
                          _c("v-spacer"),
                          _c(
                            "v-btn",
                            {
                              staticStyle: { width: "80px" },
                              attrs: { color: "primary", small: "" },
                              on: {
                                click: function($event) {
                                  _vm.menuOpen = false
                                  _vm.saveVisibleColumns()
                                }
                              }
                            },
                            [_vm._v(" " + _vm._s(_vm.$t("Save")) + " ")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "col-1 pa-0 d-flex align-center justify-center ml-4",
              staticStyle: { "align-self": "end" }
            },
            [
              _c("v-divider", {
                staticStyle: { "min-height": "36px" },
                attrs: { vertical: "" }
              })
            ],
            1
          ),
          _c("v-text-field", {
            staticClass: "form-input ml-3 col-2 mandatory",
            attrs: {
              outlined: "",
              dense: "",
              "hide-details": "",
              label: _vm.$t("Sensor ID"),
              placeholder: _vm.$t("Input Sensor ID"),
              clearable: ""
            },
            on: {
              keyup: function($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                ) {
                  return null
                }
                return _vm.searchRecords($event)
              }
            },
            model: {
              value: _vm.searchBy.sensorCode,
              callback: function($$v) {
                _vm.$set(_vm.searchBy, "sensorCode", $$v)
              },
              expression: "searchBy.sensorCode"
            }
          }),
          _c("v-select", {
            staticClass: "form-select ml-3 col-2 mandatory",
            attrs: {
              label: _vm.$t("Sensor Status"),
              placeholder: _vm.$t("Select Sensor Status"),
              outlined: "",
              dense: "",
              "hide-details": "",
              items: _vm.exportStates,
              "item-text": "text",
              "item-value": "val",
              clearable: ""
            },
            model: {
              value: _vm.searchBy.exportState,
              callback: function($$v) {
                _vm.$set(_vm.searchBy, "exportState", $$v)
              },
              expression: "searchBy.exportState"
            }
          }),
          _c(
            "v-btn",
            {
              staticClass: "btn type-search ml-3",
              attrs: { text: "" },
              on: { click: _vm.searchRecords }
            },
            [_vm._v(_vm._s(_vm.$t("Search")))]
          )
        ],
        1
      ),
      _c(
        "v-data-table",
        {
          staticClass: "tbl-type01 mt-10",
          attrs: {
            "item-key": "id",
            headers: _vm.filteredRecordHeaders,
            items: _vm.tableItems,
            page: _vm.page,
            "hide-default-footer": true,
            options: _vm.options,
            "server-items-length": _vm.totalRecords
          },
          on: {
            "update:page": function($event) {
              _vm.page = $event
            },
            "update:options": function($event) {
              _vm.options = $event
            }
          },
          scopedSlots: _vm._u([
            {
              key: "item.download",
              fn: function(props) {
                return [
                  _c(
                    "v-btn",
                    {
                      staticClass: "mx-2",
                      attrs: {
                        disabled:
                          props.item.exportState !== "COMPLETED" ||
                          _vm.btnShowLogExport ||
                          props.item.count === 0,
                        icon: ""
                      },
                      on: {
                        click: function() {
                          return _vm.toDownloadSensorLogs(props.item)
                        }
                      }
                    },
                    [
                      _c("img", {
                        staticClass: "ico_Sensor",
                        attrs: {
                          src: _vm.getExportIcon(props.item),
                          alt: "solum esl dashboard"
                        }
                      })
                    ]
                  )
                ]
              }
            }
          ])
        },
        [
          _c("template", { slot: "no-data" }, [
            _c("p", [_vm._v(" " + _vm._s(_vm.$t("No data available")) + " ")])
          ])
        ],
        2
      ),
      _c("div", { staticClass: "table-options" }),
      _c("Pagination", {
        attrs: {
          pageInfoText: _vm.pageInfoText,
          pageIndex: _vm.pageIndex,
          rowPerPage: _vm.rowPerPage,
          goToPageInput: _vm.goToPageInput,
          totalPages: _vm.totalPages
        },
        on: {
          paging: function($event) {
            return _vm.paging($event)
          },
          updatePage: function($event) {
            return _vm.updatePage($event)
          }
        }
      }),
      _c("a", { ref: "link", style: { display: "none" } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }